import styled, { css } from "styled-components";

import { Divider as DefaultDivider } from "@material-ui/core";

import Loader from "components/Layout/Loader";
import SearchDefault from "components/Input/Search";

import { COLORS } from "constants/colorScheme";

export const BackButtonWrapper = styled.div`
  display: flex;
  margin-left: 26px;
`;

export const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  margin-bottom: 30px;
`;

export const SearchControls = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SearchControlWrapper = styled.div`
  &:not(:last-child) {
    margin-right: 30px;
  }
`;

export const Search = styled(SearchDefault)`
  width: 300px;
`;

export const CategoryCardWrapper = styled.div`
  :not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const MealTypeWrapper = styled.div`
  :not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const MealTypeList = styled.div`
  margin: -10px;
  padding: 10px;

  border-radius: 8px;

  ${({ isDraggingOver }: { isDraggingOver?: boolean }) =>
    isDraggingOver &&
    css`
      background-color: ${COLORS.CYAN_LIGHT};
    `}
`;

export const ScrollLoader = styled(Loader)`
  height: 100px;
`;

export const OverflowLoader = styled(Loader)`
  position: absolute;
  z-index: 10;

  background-color: ${COLORS.WHITE_40};
`;

export const WeekCategoryContainer = styled.div`
  display: flex;
  flex-direction: column;

  :not(:last-child) {
    margin-bottom: 40px;
  }
`;

export const Divider = styled(DefaultDivider)`
  && {
    margin: 16px 0;
  }
`;

export const WeekCategoryPageSubtitle = styled.div`
  margin-bottom: 32px;
`;

export const WeekCategoryHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Wrapper = styled.div``;

export const HeaderControlsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderControl = styled.div`
  ${({ isDropdown }: { isDropdown?: boolean }) =>
    isDropdown &&
    css`
      min-width: 200px;
    `}

  &:not(:last-child) {
    margin-right: 32px;
  }
`;

export const PublishStatusWrapper = styled.div`
  margin-left: 32px;
  flex-shrink: 0;
`;
